import React, { FC } from "react";
import "../intakeFormSteps.scss";

interface RadioOptionCardProps {
  id: string;
  name: string;
  label: string;
  description?: string;
  selected: boolean;
  onChange: () => void;
}

const RadioOptionCard: FC<RadioOptionCardProps> = ({
  id,
  name,
  label,
  description,
  selected,
  onChange,
}) => {
  return (
    <label
      className={`intake-form-step__option-card ${
        selected ? "intake-form-step__option-card--selected" : ""
      }`}
      htmlFor={id}
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={selected}
        onChange={onChange}
        className="intake-form-step__option-card__radio"
      />
      <div className="intake-form-step__option-card__content">
        <span className="intake-form-step__option-card__label">{label}</span>
        {description && (
          <span className="intake-form-step__option-card__description">
            {description}
          </span>
        )}
      </div>
      <div className="intake-form-step__option-card__indicator">
        {selected && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#0377C4" />
            <path
              d="M8 12L11 15L16 9"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </label>
  );
};

export default RadioOptionCard;
